import { z } from "zod";

export const productAccordionConfigSchema = z.array(
  z.object({
    name: z.union([
      z.literal("description"),
      z.literal("specification"),
      z.literal("howToUse"),
      z.literal("ingredients"),
      z.literal("buyingGuides"),
      z.literal("outlet"),
      z.literal("brand"),
      z.literal("deliveryOptions"),
      z.literal("reviews"),
      z.literal("sizeAndFit"),
      z.literal("specialOffers"),
      z.literal("returnsAndExchange"),
      z.literal("measurements"),
    ]),
    open: z.boolean().optional(),
  }),
);

export type AccordionConfiguration = z.infer<
  typeof productAccordionConfigSchema
>;
